import Vue from 'vue'
import VueRouter from 'vue-router'
import { getDemoFileUrl } from '@/demo/runtime'

Vue.use(VueRouter)

// 解决导航栏或者底部导航tabBar中的vue-router在3.0版本以上频繁点击菜单报错的问题。
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/demo-login',
    name: 'DemoLogin',
    meta: { name: '演示登录' },
    component: () => import('../views/Login.vue')
  },
  {
    path: '/demo',
    name: 'DemoManager',
    component: () => import('../views/Manager.vue'),
    redirect: '/demo/home',
    children: [
      { path: '403', name: 'NoAuthDemo', meta: { name: '无权限' }, component: () => import('../views/manager/403') },
      { path: 'home', name: 'HomeDemo', meta: { name: '系统首页' }, component: () => import('../views/manager/Home') },
      { path: 'admin', name: 'AdminDemo', meta: { name: '管理员信息' }, component: () => import('../views/manager/Admin') },
      { path: 'adminPerson', name: 'AdminPersonDemo', meta: { name: '个人信息' }, component: () => import('../views/manager/AdminPerson') },
      { path: 'password', name: 'PasswordDemo', meta: { name: '修改密码' }, component: () => import('../views/manager/Password') },
      { path: 'notice', name: 'NoticeDemo', meta: { name: '公告信息' }, component: () => import('../views/manager/Notice') },
      { path: 'carbonVerification', name: 'CarbonVerificationDemo', meta: { name: '碳核查支撑文件' }, component: () => import('../views/manager/CarbonVerification') },
      { path: 'supplyChainCarbon', name: 'SupplyChainCarbonDemo', meta: { name: '供应链碳排放管理' }, component: () => import('../views/manager/SupplyChainCarbon') },
      { path: 'carbonQuotaMonthly', name: 'CarbonQuotaMonthlyDemo', meta: { name: '碳配额数据管理' }, component: () => import('../views/manager/CarbonQuotaMonthly') },
      { path: 'carbonTransaction', name: 'CarbonTransactionDemo', meta: { name: '配额交易记录' }, component: () => import('../views/manager/CarbonTransaction') },
      { path: 'energyEntity', name: 'EnergyEntityDemo', meta: { name: '能源实体管理' }, component: () => import('../views/manager/EnergyEntity') },
      { path: 'energyType', name: 'EnergyTypeDemo', meta: { name: '能源类型管理' }, component: () => import('../views/manager/EnergyType') },
      { path: 'energyConsumption', name: 'EnergyConsumptionDemo', meta: { name: '能源消费记录管理' }, component: () => import('../views/manager/EnergyConsumption') },
      { path: 'productionData', name: 'ProductionDataDemo', meta: { name: '生产数据管理' }, component: () => import('../views/manager/ProductionData') },
      { path: 'energyBudget', name: 'EnergyBudgetDemo', meta: { name: '能源预算管理' }, component: () => import('../views/manager/EnergyBudget') },
      { path: 'benchmarkData', name: 'BenchmarkDataDemo', meta: { name: '对标数据管理' }, component: () => import('../views/manager/BenchmarkData') },
      { path: 'productCarbonFootprint', name: 'ProductCarbonFootprintDemo', meta: { name: '产品碳足迹管理' }, component: () => import('../views/manager/ProductCarbonFootprint') },
    ]
  },
  {
    path: '/demo/front',
    name: 'DemoFront',
    component: () => import('../views/Front.vue'),
    redirect: '/demo/front/home',
    children: [
      { path: 'home', name: 'FrontHomeDemo', meta: { name: '系统首页' }, component: () => import('../views/front/Home') },
      { path: 'person', name: 'PersonDemo', meta: { name: '个人信息' }, component: () => import('../views/front/Person') },
      { path: 'energyQueryAll', name: 'EnergyQueryAllDemo', meta: { name: '综合能耗查询' }, component: () => import('../views/front/EnergyQueryAll') },
      { path: 'energyIntensity', name: 'EnergyIntensityDemo', meta: { name: '能源消费量和强度' }, component: () => import('../views/front/EnergyIntensity') },
      { path: 'energyAnalysis', name: 'EnergyAnalysisDemo', meta: { name: '能源分析与策略' }, component: () => import('../views/front/EnergyAnalysis') },
      { path: 'energyBenchmark', name: 'EnergyBenchmarkDemo', meta: { name: '能效对标' }, component: () => import('../views/front/EnergyBenchmark') },
      { path: 'energyFlow', name: 'EnergyFlowDemo', meta: { name: '能流分析与优化' }, component: () => import('../views/front/EnergyFlow') },
      { path: 'budgetManagement', name: 'BudgetManagementDemo', meta: { name: '预算管理' }, component: () => import('../views/front/BudgetManagement') },
      { path: 'carbonAccounting', name: 'CarbonAccountingDemo', meta: { name: '碳排放核算' }, component: () => import('../views/front/CarbonAccounting') },
      { path: 'productLineCarbonFootprint', name: 'ProductLineCarbonFootprintDemo', meta: { name: '产品线碳足迹' }, component: () => import('../views/front/ProductLineCarbonFootprint') },
      { path: 'supplyChainCarbon', name: 'SupplyChainCarbonDemo', meta: { name: '供应链碳管理' }, component: () => import('../views/front/SupplyChainCarbon') },
      { path: 'carbonVerification', name: 'CarbonVerificationDemo', meta: { name: '碳核查支撑' }, component: () => import('../views/front/CarbonVerification') },
      { path: 'carbonAssetManagement', name: 'CarbonAssetManagementDemo', meta: { name: '碳资产管理' }, component: () => import('../views/front/CarbonAssetManagement') },
    ]
  },
  {
    path: '/',
    name: 'Manager',
    component: () => import('../views/Manager.vue'),
    redirect: '/home',  // 重定向到主页
    children: [
      { path: '403', name: 'NoAuth', meta: { name: '无权限' }, component: () => import('../views/manager/403') },
      { path: 'home', name: 'Home', meta: { name: '系统首页' }, component: () => import('../views/manager/Home') },
      { path: 'admin', name: 'Admin', meta: { name: '管理员信息' }, component: () => import('../views/manager/Admin') },
      { path: 'adminPerson', name: 'AdminPerson', meta: { name: '个人信息' }, component: () => import('../views/manager/AdminPerson') },
      { path: 'password', name: 'Password', meta: { name: '修改密码' }, component: () => import('../views/manager/Password') },
      { path: 'notice', name: 'Notice', meta: { name: '公告信息' }, component: () => import('../views/manager/Notice') },
      { path: 'carbonVerification', name: 'CarbonVerification', meta: { name: '碳核查支撑文件' }, component: () => import('../views/manager/CarbonVerification') },
      { path: 'supplyChainCarbon', name: 'SupplyChainCarbon', meta: { name: '供应链碳排放管理' }, component: () => import('../views/manager/SupplyChainCarbon') },
      { path: 'carbonQuotaMonthly', name: 'CarbonQuotaMonthly', meta: { name: '碳配额数据管理' }, component: () => import('../views/manager/CarbonQuotaMonthly') },
      { path: 'carbonTransaction', name: 'CarbonTransaction', meta: { name: '配额交易记录' }, component: () => import('../views/manager/CarbonTransaction') },
      { path: 'energyEntity', name: 'EnergyEntity', meta: { name: '能源实体管理' }, component: () => import('../views/manager/EnergyEntity') },
      { path: 'energyType', name: 'EnergyType', meta: { name: '能源类型管理' }, component: () => import('../views/manager/EnergyType') },
      { path: 'energyConsumption', name: 'EnergyConsumption', meta: { name: '能源消费记录管理' }, component: () => import('../views/manager/EnergyConsumption') },
      { path: 'productionData', name: 'ProductionData', meta: { name: '生产数据管理' }, component: () => import('../views/manager/ProductionData') },
      { path: 'energyBudget', name: 'EnergyBudget', meta: { name: '能源预算管理' }, component: () => import('../views/manager/EnergyBudget') },
      { path: 'benchmarkData', name: 'BenchmarkData', meta: { name: '对标数据管理' }, component: () => import('../views/manager/BenchmarkData') },
      { path: 'productCarbonFootprint', name: 'ProductCarbonFootprintManage', meta: { name: '产品碳足迹管理' }, component: () => import('../views/manager/ProductCarbonFootprint') },
    ]
  },
  {
    path: '/front',
    name: 'Front',
    component: () => import('../views/Front.vue'),
    redirect: '/front/home',  // 重定向到用户首页
    children: [
      { path: 'home', name: 'FrontHome', meta: { name: '系统首页' }, component: () => import('../views/front/Home') },
      { path: 'person', name: 'Person', meta: { name: '个人信息' }, component: () => import('../views/front/Person') },
      
      // 能源管理模块
      { path: 'energyQueryAll', name: 'EnergyQueryAll', meta: { name: '综合能耗查询' }, component: () => import('../views/front/EnergyQueryAll') },
      { path: 'energyIntensity', name: 'EnergyIntensity', meta: { name: '能源消费量和强度' }, component: () => import('../views/front/EnergyIntensity') },
      { path: 'energyAnalysis', name: 'EnergyAnalysis', meta: { name: '能源分析与策略' }, component: () => import('../views/front/EnergyAnalysis') },
      
      // 能效管理模块
      { path: 'energyBenchmark', name: 'EnergyBenchmark', meta: { name: '能效对标' }, component: () => import('../views/front/EnergyBenchmark') },
      { path: 'energyFlow', name: 'EnergyFlow', meta: { name: '能流分析与优化' }, component: () => import('../views/front/EnergyFlow') },
      
      // 碳排放管理模块
      { path: 'budgetManagement', name: 'BudgetManagement', meta: { name: '预算管理' }, component: () => import('../views/front/BudgetManagement') },
      { path: 'carbonAccounting', name: 'CarbonAccounting', meta: { name: '碳排放核算' }, component: () => import('../views/front/CarbonAccounting') },
      { path: 'productLineCarbonFootprint', name: 'ProductLineCarbonFootprint', meta: { name: '产品线碳足迹' }, component: () => import('../views/front/ProductLineCarbonFootprint') },
      // 碳资产管理子模块
      { path: 'supplyChainCarbon', name: 'SupplyChainCarbon', meta: { name: '供应链碳管理' }, component: () => import('../views/front/SupplyChainCarbon') },
      { path: 'carbonVerification', name: 'CarbonVerification', meta: { name: '碳核查支撑' }, component: () => import('../views/front/CarbonVerification') },
      { path: 'carbonAssetManagement', name: 'CarbonAssetManagement', meta: { name: '碳资产管理' }, component: () => import('../views/front/CarbonAssetManagement') },
    ]
  },
  { path: '/login', name: 'Login', meta: { name: '登录' }, component: () => import('../views/Login.vue') },
  { path: '/activate', name: 'Activate', meta: { name: '系统授权' }, component: () => import('../views/Activate.vue') },
  { path: '/register', name: 'Register', meta: { name: '注册' }, component: () => import('../views/Register.vue') },
  { path: '*', name: 'NotFound', meta: { name: '无法访问' }, component: () => import('../views/404.vue') },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫 - 根据用户角色跳转到不同页面
router.beforeEach((to ,from, next) => {
  let user = JSON.parse(localStorage.getItem("xm-user") || '{}');
  if (to.path === '/demo-login') {
    next()
    return
  }
  if (to.path === '/') {
    if (!user.role) {
      next('/demo-login')
      return
    }
    if (user.role === 'ADMIN') {
      next('/demo/home')
    } else if (user.role === 'USER') {
      next('/demo/front/home')
    } else {
      next('/demo-login')
    }
    return
  }
  if (to.path === '/') {
    if (user.role) {
      // 根据不同角色跳转到不同的首页
      if (user.role === 'ADMIN') {
        next('/home')  // 管理员跳转到管理员首页
      } else if (user.role === 'USER') {
        next('/front/home')  // 普通用户跳转到用户首页
      } else {
        next('/login')
      }
    } else {
      next('/login')
    }
  } else {
    next()
  }
})

router.afterEach(() => {
  document.title = '能碳平台演示版'
})

export default router
